document.addEventListener("turbolinks:load", function () {
    // Confirmation buttons
    const saveButton = document.querySelector("#ia-save-button");
    const publishButton = document.querySelector("#ia-publish-button");

    // Validated fields and errors
    const assignmentName = document.querySelector("#assignment-name-field");
    const assignmentNameError = document.querySelector("#assignment-name-error");
    const startDatePicker = document.querySelector("#start-datetimepicker");
    const startDateError = document.querySelector("#start-date-error");
    const dueDatePicker = document.querySelector("#due-datetimepicker");
    const dueDateError = document.querySelector("#due-date-error");
    const folderName = document.querySelector("#folder-name");
    const folderNameError = document.querySelector("#folder-name-error");

    // Folder dropdown
    const folderDropdown = document.querySelector("#assignment_assignment_group_id");

    // Determine if this is the correct page by finding a unique element
    if (saveButton) {
        // Disable/enable the save and publish buttons depending on whether any errors are present
        const toggleConfirm = () => {
            toggleIaButton(saveButton);
            toggleIaButton(publishButton);
        };
        
        // Assignment Name Validation
        assignmentName.addEventListener("blur", () => {
            // If the string is empty or only white space, show the error. Otherwise hide it
            assignmentName.value.trim() === "" ? showIaError(assignmentNameError) : hideIaError(assignmentNameError);
            toggleConfirm();
        });

        // Start Date Setup
        startDatePicker.addEventListener("click", () => {
            // Set the selected start date to the current date
            startDatePicker._flatpickr.setDate(new Date());
        });
        
        // Start Date Validation
        startDatePicker.addEventListener("change", () => {
            const startDate = new Date(startDatePicker.value);
            let dueDate = new Date(dueDatePicker.value);
            // If the due date is before or equal to the start date, set it to 1 week after the start date at 11:59
            if (dueDate <= startDate) {
                // Create the new date
                const newDueDate = new Date(startDate.setDate(startDate.getDate() + 7));
                newDueDate.setHours(23,59,59,999);
                // Update the due date on the page and locally for validation
                dueDatePicker._flatpickr.setDate(newDueDate);
                dueDate = newDueDate;
            }
            // If the due date is before the start date, show the error. Otherwise hide it
            dueDate <= startDate ? showIaError(startDateError) : hideIaError(startDateError);
            // If the start date is before the due date, hide the due date error
            if (startDate < dueDate) hideIaError(dueDateError);
            toggleConfirm();
        });

        // Due Date Setup
        dueDatePicker.addEventListener("focus", () => {
            // Set the minimum due date to the start date
            dueDatePicker._flatpickr.set("minDate", (new Date(startDatePicker.value)));
        });

        // Due Date Validation
        dueDatePicker.addEventListener("change", () => {
            const currentTime = new Date();
            const startDate = new Date(startDatePicker.value);
            const dueDate = new Date(dueDatePicker.value);
            // If the due date is before the start date or current date, show the error. Otherwise hide it
            const dueDateTooEarly = dueDate <= startDate || dueDate < currentTime;
            dueDateTooEarly ? showIaError(dueDateError) : hideIaError(dueDateError);
            // If the due date is after the start date, hide the start date error
            if (dueDate > startDate) hideIaError(startDateError);
            toggleConfirm();
        });

        // Folder Name Validation
        folderName.addEventListener("blur", () => {
            // If the string is empty or only white space, show the error. Otherwise hide it
            folderName.value.trim() === "" ? showIaError(folderNameError) : hideIaError(folderNameError);
            toggleConfirm();
        });

        // Folder Option Selection
        folderDropdown.addEventListener("change", () => {
            // If the "Create new" option is selected (value of "-1"), show or hide the error as appropriate
            if (folderDropdown.value === "-1") {
                // If the string is empty or only white space, show the error. Otherwise hide it
                folderName.value.trim() === "" ? showIaError(folderNameError) : hideIaError(folderNameError);
            }
            // If anything other than "Create new" is selected, hide the error
            else {
                hideIaError(folderNameError);
            }
            toggleConfirm();
        });
    }
})